/**
 * Enfoque de un aspecto por tipo de programa.
 *
 * Espejo del enum `App\Enums\Enfoque` del backend. `general` es el aspecto
 * normal, que aplica siempre; los demás son VARIANTES que solo se muestran en
 * la versión de su mismo enfoque.
 *
 * Las variantes de un mismo aspecto comparten un único slot de peso, de ahí que
 * el cálculo de pesos las colapse (ver `pesosGrupo`).
 */

// Enfoque de un aspecto (componente) por tipo de programa. Espejo del enum
// backend App\Enums\Enfoque. 'general' = aspecto normal (aplica siempre); los
// demás son variantes que solo se muestran en la versión de su mismo enfoque.
// Las variantes de un mismo aspecto comparten un único slot de peso.

export type Enfoque =
  | 'general'
  | 'tyt'
  | 'universitario'
  | 'especialidad_mq'
  | 'maestria'
  | 'doctorado'

/**
 * Catálogo completo de enfoques con su etiqueta visible.
 *
 * El orden es el de presentación en los selectores: `general` primero por ser el
 * caso por defecto.
 */
export const ENFOQUES: { value: Enfoque; label: string }[] = [
  { value: 'general', label: 'General' },
  { value: 'tyt', label: 'Para programas T y T' },
  { value: 'universitario', label: 'Para programas profesionales universitarios' },
  { value: 'especialidad_mq', label: 'Para especialidades médico quirúrgicas' },
  { value: 'maestria', label: 'Para Maestrías' },
  { value: 'doctorado', label: 'Para Doctorados' },
]

/** Enfoques que la versión puede elegir (excluye General). */
export const ENFOQUES_ESPECIFICOS = ENFOQUES.filter(e => e.value !== 'general')

/**
 * Etiqueta visible de un enfoque.
 *
 * Tolerante por diseño: un valor nulo, vacío o desconocido devuelve «General» en
 * lugar de lanzar o mostrar el código crudo. Los componentes anteriores a que
 * existieran los enfoques no tienen el campo, y deben leerse como generales.
 *
 * @param v - Valor de enfoque, posiblemente nulo o no reconocido.
 * @returns Etiqueta legible; «General» como respaldo.
 */
export function etiquetaEnfoque(v?: string | null): string {
  return ENFOQUES.find(e => e.value === v)?.label ?? 'General'
}

/** ¿El componente es una variante por enfoque? (enfoque específico, no General). */
export function esVarianteEnfoque(v?: string | null): boolean {
  return v != null && v !== 'general'
}
